import type { Prototype } from "../prototype-types";

export const bronwynGemmillPrototypes: Prototype[] = [
  {
    id: "bg-brand-page-nav-xp",
    name: "Brand Page — V3 Header + Nav XP",
    path: "/bg/brand-page-nav-xp",
    description:
      "V3 brand page header with category navigation XP: desktop sidebar, sticky filter + search toolbar, product grid, and reviews below the grid. Based on P.F. Candle Co.",
    owner: "Bronwyn Gemmill",
    createdAt: "2026-07-03",
    lastUpdated: "2026-07-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/bg-brand-page-nav-xp.png",
  },
  {
    id: "bg-brand-page-reviews-in-grid",
    name: "Brand page - mid grid content variations",
    path: "/bg/brand-page-reviews-in-grid",
    description:
      "Mid-grid content variations on the category navigation XP brand page: reviews in a grid row (3-card preview) and a Reviews sidebar destination. Builds on the V3 header + nav layout.",
    owner: "Bronwyn Gemmill",
    createdAt: "2026-07-03",
    lastUpdated: "2026-07-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/bg-brand-page-reviews-in-grid.png",
  },
  {
    id: "sidecart-quantity-picker",
    name: "Sidecart Quantity Picker",
    path: "",
    description:
      "Lightweight sidecart prototype similar to the brand page: slide-out drawer with line items and quantity picker (+/−), mock checkout.",
    owner: "Bronwyn",
    createdAt: "2026-03-18",
    lastUpdated: "2026-03-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/25a0bc579c91aaba35d0f4fee685e0806f11f966b24acd765d58f9d67c49c600.png",
    creationTool: "cursor",
  },
  {
    id: "bg-brand-page-grid-carousels",
    name: "Brand page grid carousels",
    path: "/bg/brand-page-grid-carousels",
    description:
      "Brand page product grid with injected recommendation carousels, using the category-nav explorations variant 9 layout (pills above grid + sort). Staggered: after 60 / 90 / 120 tiles in a 150-product grid. Stacked at bottom: all three after 40 products. Tile treatment: default, or white tiles on a grey carousel. Columns: extra column (6), or match the 5-column product grid.",
    owner: "Bronwyn Gemmill",
    createdAt: "2026-08-23",
    lastUpdated: "2026-08-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/a36c6a4bffb738e9cc17dcd37bf4fdb1452bb682ea225144388ee13cb9385a02.png",
    creationTool: "cursor",
  },
];
